<div class="rich-text-div">
  @if (dataVersion >= 4 && htmlItem) {
    <div class="text-start" [innerHTML]="byPassHTML(htmlItem)"></div>
  }
  @if (dataVersion < 4) {
    <div class="text-start" [innerHTML]="byPassHTML($safeNavigationMigration(item.templateOptions?.html))"></div>
  }
</div>